import type { Env } from "./env-tabs.js";

export type ScreenState = "OK" | "AWAITING_SYNC" | "OTHER_ENV_ONLY";

// 002 §7-2 (R-0005): 운영 데이터 없음+모의만 있음 = "데이터 없음"이 아니라 안내 배너.
// 둘 다 없으면 "연동 대기 중". 이 두 상태를 연동 실패로 오인하지 않도록 문구를 분리한다.
export function renderEmptyStateBanner(
  state: ScreenState,
  currentEnv: Env,
  onSwitchEnv: (env: Env) => void,
): HTMLElement | null {
  if (state === "OK") return null;

  const banner = document.createElement("div");

  if (state === "AWAITING_SYNC") {
    banner.className = "banner banner-waiting";
    banner.innerHTML = `<span>연동 대기 중입니다 — JaTem 외부연동이 아직 데이터를 보내지 않았습니다.</span>`;
    return banner;
  }

  // OTHER_ENV_ONLY
  banner.className = "banner banner-info";
  const otherEnv: Env = currentEnv === "운영" ? "모의" : "운영";
  const label = document.createElement("span");
  label.textContent =
    currentEnv === "운영"
      ? "현재 모의 데이터만 있습니다."
      : "현재 운영 데이터만 있습니다.";
  const switchBtn = document.createElement("button");
  switchBtn.textContent = `${otherEnv} 보기`;
  switchBtn.addEventListener("click", () => onSwitchEnv(otherEnv));
  banner.appendChild(label);
  banner.appendChild(switchBtn);
  return banner;
}
